import axios from 'axios';
import { getNoCache } from '../utils/NoCacheUtils';
export interface EnvironmentType {
  environment: 'default' | 'develop' | 'homolog' | 'preprod' | 'production';
  isOffline: boolean;
  apis: {
    backofficeProjetos: string;
    bff: string;
    documentosS3: string;
    users: string;
    assessoria: string;
    contrato: string;
  };
  links: {
    changePassword: string;
    forgotPasswordEmail: string;
    forgotPasswordPSMS: string;
  };
  auth: {
    authUrl: string;
    tokenUrl: string;
    wso2LogoutUrl: string;
    identityClientId: string;
    redirectUrl: string;
    logofRedirectUrl: string;
  };
}

let loadedEnvironment: EnvironmentType | null = null;
export const loadEnvironments = async (
  callbackSuccess: (env: EnvironmentType) => void
) => {
  if (loadedEnvironment) {
    callbackSuccess(loadedEnvironment);
    return;
  }
  try {
    const response = await axios.get(
      '/programaseducacionais/admin/assets/environments/default.json?noCache=' +
      getNoCache()
    );
    loadedEnvironment = response.data;
    callbackSuccess(response.data);
  } catch (error) {
    console.error('Variáveis de ambiente não carregadas:', error);
  }
};

export const getApis = () => {
  if (!loadedEnvironment) {
    throw new Error('Variáveis de ambiente não carregadas!');
  }
  return loadedEnvironment;
};